import { Contact } from '../types';

export const contact: Contact = {
    email: 'alirajab.dev@gmail.com',
    phone: '+963-992840260',
    whatsapp: '+963992840260',
    linktree: 'https://linktr.ee/alirajab',
    github: 'https://github.com/AliRajab12',
    linkedin: 'https://www.linkedin.com/in/ali-rajab-ne',
};
